import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Utils from "../../Utils";
import Button from "../../lib/Button";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class LeaveConfirmationPopup extends Popup
{
    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        
        
        this._disabledBg.alpha = 0;

        let base: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.popup_base.texture );
        base.position.set( ServiceLocator.app.width * 0.5 - base.texture.width * 0.5, ServiceLocator.app.height * 0.5 - base.height * 0.5 );
        this._root.addChild( base );

        let message: PIXI.Text = new PIXI.Text( "Are you sure you want to leave?", { 
            fontFamily: "jaro_regular", 
            fontSize: 38, 
            fill: 0xffffff,
            wordWrap: true,
            wordWrapWidth: ServiceLocator.app.width * 0.8,
            align: "center" } );
        message.anchor.set( 0.5 );
        message.position.set( base.texture.width * 0.5, 194 + 70 );
        base.addChild( message );

        let acceptBtn: Button = new Button( { on: "popup_button_yes", pressed: "popup_button_yes_pressed" } );
        acceptBtn.anchor.set( 0.5 );
        acceptBtn.position.set( base.texture.width * 0.5 - 142, 350 + 80 );
        base.addChild( acceptBtn );
        acceptBtn.on( "pointertap", () => { this._onAcceptBtn_Click(); } );

        let cancelBtn: Button = new Button( { on: "popup_button_no", pressed: "popup_button_no_pressed" } );
        cancelBtn.anchor.set( 0.5 );
        cancelBtn.position.set( base.texture.width * 0.5 + 142, acceptBtn.y );
        base.addChild( cancelBtn );
        cancelBtn.on( "pointertap", () => { this._onCancelBtn_Click(); } );
    }

        private _onAcceptBtn_Click(): void
        {
            this._onClosed.dispatch( this, true );
        }

        private _onCancelBtn_Click(): void
        {
            this._onClosed.dispatch( this, false );
        }

    // #endregion //
}